module.exports = __webpack_public_path__ + "static/media/bed-frame-set-removal.334eb322.svg";